import axios from './api';

const API_URL = '/piece-jointes/';

const getAll = async (userData) => {
  const response = await axios.get(API_URL,userData);
  return response.data;
};

const createPiece = async (id,userData) => {
  const response = await axios.post(API_URL+ id,userData);
  return response.data;
};

const deletePiece = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const PieceJointeService = {
  createPiece,
  deletePiece,
  getAll
};

export default PieceJointeService;
